/**
 * Converts a hex color to RGB components
 */
function hexToRGB(hex: string): [number, number, number] {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return [r, g, b]
}

/**
 * Converts RGB components to hex color
 */
function rgbToHex(r: number, g: number, b: number): string {
  return (
    "#" +
    [r, g, b].map((x) => Math.round(x).toString(16).padStart(2, "0")).join("")
  )
}

/**
 * Generates an array of colors interpolated between start and end colors
 * @param start - Starting hex color
 * @param end - Ending hex color
 * @param steps - Number of colors to generate (including start and end)
 * @returns Array of hex colors
 */
export function interpolateColors(
  start: string,
  end: string,
  steps: number
): string[] {
  const [r1, g1, b1] = hexToRGB(start)
  const [r2, g2, b2] = hexToRGB(end)

  const colors: string[] = []

  for (let i = 0; i < steps; i++) {
    const ratio = i / (steps - 1)

    const r = r1 + (r2 - r1) * ratio
    const g = g1 + (g2 - g1) * ratio
    const b = b1 + (b2 - b1) * ratio

    colors.push(rgbToHex(r, g, b))
  }

  return colors
}
